import { safeToNumber } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { Table, RoomRenameRequest } = protos;

/**
 * Fetches all active tables.
 * @returns {Object} A redux TockApi action.
 */
export function fetchActive(): ApiAction {
  return {
    TockApi: {
      getListProto: '/table',
      type: AppConstants.TABLES_FETCH_ALL,
    },
  };
}

/**
 * Fetches all archived
 * @returns {Object} A redux TockApi action.
 */
export function fetchArchived(): ApiAction {
  return {
    TockApi: {
      getListProto: '/table/archived',
      type: AppConstants.TABLES_FETCH_ARCHIVED,
    },
  };
}

/**
 * Create a table.
 *
 * @param {Table} table The table to create.
 * @returns {Object} A redux TockApi action.
 */
export function create(table: Partial<Table>): ApiAction {
  const request = Table.fromObject(table);

  return {
    TockApi: {
      postProto: '/table',
      type: AppConstants.TABLES_ADD,
      request,
      toast: 'Table created',
    },
  };
}

/**
 * Update a table.
 *
 * @param {Table} table The table to update.
 * @returns {Object} A redux TockApi action.
 */
export function update(table: Table): ApiAction {
  const request = Table.fromObject(table);

  return {
    TockApi: {
      putProto: '/table',
      type: AppConstants.TABLES_UPDATE,
      request,
      toast: 'Table updated',
    },
  };
}

export function renameRoom(roomNameRequest: RoomRenameRequest): ApiAction {
  const request = RoomRenameRequest.fromObject(roomNameRequest);

  return {
    TockApi: {
      putProto: '/floorplan/room/rename',
      type: AppConstants.TABLES_RENAME_ROOM,
      request,
      toast: 'Room renamed',
    },
  };
}

/**
 * Remove a table.
 *
 * @param {Table} table The table to remove.
 * @returns {Object} A redux TockApi action.
 */
export function remove(table: Table): ApiAction {
  return {
    TockApi: {
      deleteProto: `/table/${safeToNumber(table.id)}`,
      type: AppConstants.TABLES_DELETE,
      request: table,
      context: { deletedTable: table },
      toast: 'Table deleted',
    },
  };
}

export function selectRoom(roomId: string): BaseTockAction {
  return {
    type: AppConstants.TABLES_SELECT_ROOM,
    payload: roomId,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function uploadTables(file: any): ApiAction {
  return {
    TockApi: {
      postFile: `/table/csv/upload`,
      type: AppConstants.NULL,
      request: file,
      toast: 'Tables uploaded successfully',
    },
  };
}
